import axios from 'axios';
import queryString from 'query-string';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const VISITOR_KEY = 'wymc_visitor_id';
const VISIT_SENT_KEY = 'wymc_visit_sent';

// The iOS app is this site inside a WebView opened with ?device=iphone.
export function getDevice() {
  const { device } = queryString.parse(window.location.search);
  return device === 'iphone' ? 'iphone' : 'web';
}

// Anonymous id so the admin panel can count unique visitors. Lives only in
// this browser; it is never tied to a name until someone buys a code.
export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch (e) {
    return undefined;
  }
}

// Every call to the backend goes through here so it carries the device and
// visitor headers the activity log uses.
const api = axios.create({ baseURL: BASE_URL });
api.interceptors.request.use((config) => {
  config.headers['X-Device'] = getDevice();
  const visitorId = getVisitorId();
  if (visitorId) config.headers['X-Visitor-Id'] = visitorId;
  return config;
});

let visitSent = false;

// One page-view beacon per browser tab session. Guarded twice: the module
// flag covers React StrictMode's double effect, sessionStorage covers full
// page reloads between /, /about etc.
export function trackVisit() {
  if (visitSent) return;
  visitSent = true;
  try {
    if (sessionStorage.getItem(VISIT_SENT_KEY)) return;
    sessionStorage.setItem(VISIT_SENT_KEY, '1');
  } catch (e) {
    // storage blocked: still send, at worst one extra visit per page load
  }
  api
    .post('/api/track/visit', {
      path: window.location.pathname,
      referrer: document.referrer || undefined,
      device: getDevice(),
    })
    .catch(() => {});
}

export default api;
